<template>
  <div class="alert alert-primary">
    <span v-if="!xmlJustify">
      O XML da nota fiscal foi carregado, e os valores encontrados são de
      <strong>{{ formatToCurrencyBr(noteValue) }}</strong> como total e
      <strong>{{ formatToCurrencyBr(noteValueNet) }}</strong> como líquido. A
      medição total deve corresponder a um destes valores.
    </span>
    <span v-else>
      Essa medição não possui arquivo XML. Justificativa:
      <strong>{{ xmlJustify }}</strong>
    </span>
  </div>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'

export default {
  name: 'InfoMeasureItens',

  props: {
    noteValue: {
      type: Number,
      required: false,
    },
    noteValueNet: {
      type: Number,
      required: false,
    },
    xmlJustify: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      formatToCurrencyBr,
    }
  },
}
</script>
